import { Volume2 } from "lucide-react";
import React, { useMemo } from "react";
import AudioPlayerForRouting from "../reusables/AudioPlayerForRouting";
import TooltipComponent from "../reusables/TooltipComponent";
import RouteSelect from "../reusables/RouteSelect";
import { Divider } from "@mui/material";

/**
 * Pure UI component for PlayRecording action
 * All logic is handled by usePlayRecordingAction hook
 */
const PlayRecordingUI = ({
  recordingValue,
  handleRecordingChange,
  containerClass,
  inputClass,
  headerSize,
  showDivider,
  useIVRStyle,
  setOpenConfigureSlotModal,
  recordings = [],
  hasValidationError = false,
  addRecordingOption,
}) => {
  const recordingOptions = useMemo(() => {
    if (!recordings) return [];
    return recordings.map((item) => ({ value: item.M.rec_id.S, label: item.M.title.S }));
  }, [recordings]);

  // Find the recording URL for audio player
  const recordingUrl = recordingValue
    ? recordings?.find((e) => e.M.rec_id.S === recordingValue)?.M.url.S
    : null;

  // Always use Volume2 icon and yellow color regardless of context
  // useIVRStyle only affects layout/styling, not the icon or color
  const Icon = Volume2;
  const iconClass = "text-yellow-500"; // Always use yellow color
  const title = "Play Recording";

  return (
    <div>
      <div className={`${containerClass}${hasValidationError ? " !bg-red-50/80" : ""}`}>
        {/* Header */}
        <div className="flex flex-nowrap items-center justify-between gap-3 mb-5">
          <div className="flex items-center min-w-0 flex-1">
            <Icon className={`${iconClass} shrink-0`} />
            <div className="min-w-0 ml-2">
              <h2 className={`${headerSize} text-gray-800`}>
                {title}
              </h2>
              <div className="text-[13px]">Play a message to callers</div>
            </div>
          </div>
          {setOpenConfigureSlotModal && (
            <button
              className="shrink-0 whitespace-nowrap text-sm text-blue-600 font-medium hover:underline text-[13px]"
              onClick={() => setOpenConfigureSlotModal(true)}
            >
              ↻ Change
            </button>
          )}
        </div>
        {showDivider && <Divider />}

        {/* Recording */}
        <div>
          <div className="flex items-center gap-1 mb-1">
            <span className="text-sm font-medium text-gray-700">Recording</span>
            {!useIVRStyle && (
              <TooltipComponent message={"Select the recording to play to callers"} />
            )}
          </div>
          <RouteSelect
            value={recordingValue || ""}
            onChange={handleRecordingChange}
            options={recordingOptions}
            placeholder="Select a recording"
            addOption={addRecordingOption}
          />
        </div>

        {recordingUrl && (
          <AudioPlayerForRouting src={recordingUrl} />
        )}
      </div>
    </div>
  );
};

export default PlayRecordingUI;
